import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import LoginFrame from '../components/login-frame';
import LoginMerchant from '../login-merchant';
import LoginUnify from '../login-unify';
import LoginSelect from '../login-select';
import Recover from '../recover';
import CommonLogin from './components/login';
import LoginQrcode from '../login-qrcode';


export const Login = (props) => {
    const { url } = useRouteMatch();

    return (
        <LoginFrame>
            <React.Fragment>
                <Switch>
                    <Route exact path={`${url}/merchant`} component={LoginMerchant}></Route>
                    <Route exact path={`${url}/qrcode`} component={LoginQrcode}></Route>
                    <Route exact path={`${url}/unify`} component={LoginUnify}></Route>
                    <Route exact path={`${url}/select`} component={LoginSelect}></Route>
                    <Route exact path={`${url}/recover`} component={Recover}></Route>
                    <Route exact path="*" component={CommonLogin}></Route>
                </Switch>
            </React.Fragment>
        </LoginFrame>
    );
};


export default Login;
